import React, { useEffect, useState } from 'react';
import { useTypedSelector } from '../../hook/useTypedSelector';
import { useActions } from '../../hook/useAction';

import './RusStat.css'
import { day, month, year } from '../../other/Date';
import RusBlock from './RusBlock';
import { fontWeight } from '@mui/system';




const Rus: React.FC = () => {


   // деструкрурізація (свій хук)
   const { error, loading, data } = useTypedSelector(state => state.StatRus)

   //замість кодного разу диспатч)
   const { fetchStatRus } = useActions()

   // вкладені обьекти(достаємо щоб не отримати андефайн)
   const personnel_units: number = data.data && data.data.stats && data.data.stats.personnel_units
   const tanks = data.data && data.data.stats && data.data.stats.tanks
   const armoured_fighting_vehicles = data.data && data.data.stats && data.data.stats.armoured_fighting_vehicles
   const artillery_systems = data.data && data.data.stats && data.data.stats.artillery_systems
   const aa_warfare_systems = data.data && data.data.stats && data.data.stats.aa_warfare_systems
   const planes = data.data && data.data.stats && data.data.stats.planes
   const helicopters = data.data && data.data.stats && data.data.stats.helicopters
   const warships_cutters = data.data && data.data.stats && data.data.stats.warships_cutters
   const cruise_missiles = data.data && data.data.stats && data.data.stats.cruise_missiles
   const uav_systems = data.data && data.data.stats && data.data.stats.uav_systems
   const special_military_equip = data.data && data.data.stats && data.data.stats.special_military_equip


   // state units
   // const [personnelUnits, setPersonnelUnits] = useState(personnel_units);
   // const [ruTanks, setRuTanks] = useState(tanks);
   // const [armouredFightingVehicles, setArmouredFightingVehicles] = useState(armoured_fighting_vehicles);
   // const [artillerySystems, setArtillerySystems] = useState(artillery_systems);
   // const [aaWarfareSystems, setAaWarfareSystems] = useState(aa_warfare_systems);
   // const [airplanes, setAirplanes] = useState(planes);
   // const [helicoptersFly, setHelicoptersFly] = useState(helicopters);
   // const [warshipsCutters, setWarshipsCutters] = useState(warships_cutters);
   // const [cruiseMissiles, setCruiseMissiles] = useState(cruise_missiles);
   // const [uavSystems, setUavSystems] = useState(uav_systems);
   // const [specialMilitaryEquip, setSpecialMilitaryEquip] = useState(special_military_equip);


   // state count units
   // personnelUnits !== personnel_units && setTimeout(setPersonnelUnits, 10, personnelUnits + 1)
   // ruTanks !== tanks && setTimeout(setRuTanks, 10, ruTanks + 1)
   // armouredFightingVehicles !== armoured_fighting_vehicles && setTimeout(setArmouredFightingVehicles, 10, armouredFightingVehicles + 1)
   // artillerySystems !== artillery_systems && setTimeout(setArtillerySystems, 10, artillerySystems + 1)
   // aaWarfareSystems !== aa_warfare_systems && setTimeout(setAaWarfareSystems, 10, aaWarfareSystems + 1)
   // airplanes !== planes && setTimeout(setAirplanes, 10, airplanes + 1)
   // helicoptersFly !== helicopters && setTimeout(setHelicoptersFly, 10, helicoptersFly + 1)
   // warshipsCutters !== warships_cutters && setTimeout(setWarshipsCutters, 50, warshipsCutters + 1)
   // cruiseMissiles !== cruise_missiles && setTimeout(setCruiseMissiles, 1, cruiseMissiles + 1)
   // uavSystems !== uav_systems && setTimeout(setUavSystems, 10, uavSystems + 1)
   // specialMilitaryEquip !== special_military_equip && setTimeout(setSpecialMilitaryEquip, 10, specialMilitaryEquip + 1)



   useEffect(() => {
      fetchStatRus(day, month)
   }, [])

   return (
      <div className='rus_stat_card'>
         <div className='title_rus_stat'>
            TOTAL LOSSES OF THE ENEMY AS OF <br />
            <span style={{ fontFamily: "Mitr", fontWeight: "500" }}>
               {day}.{month}.{year}
            </span>
         </div>
         {/* Первая линия статистики (4 блока) */}
         <div className='line_rus_stat'>
            <RusBlock
               statTwo={personnel_units}
               text={'Personel Unit'}
               img={'/img/statistics/units.png'}
            />

            <RusBlock
               statTwo={tanks}
               text={'Tanks'}
               img={'/img/statistics/tanks.png'}
            />
            <RusBlock
               statTwo={planes}
               text={'Planes'}
               img={'/img/statistics/fly.png'}
            />
            <RusBlock
               statTwo={helicopters}
               text={'Helicopters'}
               img={'/img/statistics/helic.png'}
            />
         </div>

         <div className='line_rus_stat'>
            <RusBlock
               statTwo={aa_warfare_systems}
               text={' AA Warfare Systems'}
               img={'/img/statistics/ppo.png'}
            />

            <RusBlock
               statTwo={armoured_fighting_vehicles}
               text={'Armoured Vehicles'}
               img={'/img/statistics/bmp.png'}
            />
            <RusBlock
               statTwo={artillery_systems}
               text={'Artillery Systems'}
               img={'/img/statistics/artileria.png'}
            />
            <RusBlock
               statTwo={special_military_equip}
               text={'Special Military Equip'}
               img={'/img/statistics/special.png'}
            />
         </div>

         <div className='line_rus_stat'>
            <RusBlock
               statTwo={warships_cutters}
               text={'Warships'}
               img={'/img/statistics/sea.png'}
            />
            <RusBlock
               statTwo={uav_systems}
               text={'UAV Systems'}
               img={'/img/statistics/bpla.png'}
            />
            <RusBlock
               statTwo={cruise_missiles}
               text={'Cruise Missiles'}
               img={'/img/statistics/raketa.png'}
            />
         </div>
         {/* Ссылка на инфо */}
         <div className='rus_stat_bottom_text'>
            <a href="https://facebook.com/story.php?story_fbid=pfbid036Z9rE9ewcJu33N6Dyj4SzMgmjd2LKWNGj4xDrQKmvox3yiyH7rUfq7rgA3SmXxZEl&id=100069073844828&eav=AfYVnF1OdQkrszlyxujFQ0fdfP8j5Su4zk-4Z4g4ZvoPUZNlL8prJwgG1cBe0PhgdDI&m_entstream_source=timeline&paipv=0">official data of the Ministry of Defense of Ukraine</a>
         </div>
      </div>

   )
}


export default Rus;